var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7517 8.34125L22.7517 0.34125C22.6581 0.234353 22.5428 0.148629 22.4134 0.0897865C22.2841 0.0309444 22.1437 0.000335929 22.0017 0H8.00165C7.85957 0.000335929 7.7192 0.0309444 7.58987 0.0897865C7.46055 0.148629 7.34525 0.234353 7.25165 0.34125L0.251654 8.34125C0.0883506 8.5277 0.000105526 8.76815 0.00403186 9.01597C0.00795819 9.26379 0.103776 9.50132 0.272904 9.6825L14.2729 24.6825C14.3665 24.7828 14.4797 24.8628 14.6055 24.9175C14.7313 24.9722 14.867 25.0004 15.0042 25.0004C15.1413 25.0004 15.277 24.9722 15.4028 24.9175C15.5286 24.8628 15.6418 24.7828 15.7354 24.6825L29.7354 9.6825C29.9038 9.50069 29.9988 9.26282 30.0018 9.015C30.0048 8.76719 29.9156 8.52708 29.7517 8.34125ZM26.7979 8H21.5017L17.0017 2H21.5479L26.7979 8ZM8.32415 10L12.0904 19.4163L3.3029 10H8.32415ZM21.6792 10H26.7004L17.9129 19.4163L21.6792 10ZM8.4554 2H13.0017L8.50165 8H3.2054L8.4554 2Z",
    fill: "url(#paint0_linear_668_29211)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_29211",
    x1: 0.00390446,
    y1: 25.0004,
    x2: 32.8228,
    y2: 4.52065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF69B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaring);
export default __webpack_public_path__ + "static/media/Caring.08956bdabbae697f50b9798d3588cca3.svg";
export { ForwardRef as ReactComponent };